//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            01st January 2018
//  * @type            Expand data component in Question Panel in Center Questions Component File
//  * @description -   This file renders the html and functionality for displaying expand collapse data in empty question of center questions part.
<template>
  <div class="panel-body answer_option">
    <div
      v-for="(validationDetails,key, index) in surveyQuestionWithDetails[''+qid]"
      :key="''+validationDetails.in_question_master_id+index"
      v-if="key != 'score_data'"
    >
      <!-- Display question type if availaible types -->
      <div
        v-if="index == 0 && qtypeToName[''+validationDetails['in_question_type_id']]"
      >Type: {{qtypeToName[''+validationDetails['in_question_type_id']]}}</div>
      <!-- Added to check if others score is present or not -->
      <div
        v-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS"
      >
        {{validationDetails.st_validation_name}}:
        <span
          v-if="validationDetails.st_answer_text ?  (allowOthers = 1,allowOthersScore = validationDetails.st_answer_score!='' ? validationDetails.st_answer_score : 'NA' ) :  allowOthers = 0"
        >True</span>
        <span v-else>False</span>
      </div>
      <div
        v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_SHOW_ANS_LABEL || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM || validationDetails.in_validation_id == 
        vueQueValidationConfig.VALIDATION_SHOW_TITLE || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_ACCESS_TO_GALLERY"
      >
        {{validationDetails.st_validation_name}}:
        <span v-if="validationDetails.st_answer_text">True</span>
        <span v-else>False</span>
      </div>
      <div v-else>
        <!-- Allowed number characters -->
        <div v-if="key == vueQueValidationConfig.VALIDATION_ALLOWED_CHAR">
          <div v-if="surveyQuestionWithDetails[''+qid][9]['st_answer_text'] == 1">
            {{validationDetails.st_validation_name}}:
            <span
              v-if="validationDetails.st_answer_text"
            >{{validationDetails.st_answer_text.replace(/sep/g,',')}}</span>
            <span v-else>NA</span>
          </div>
        </div>
        <!-- Address validation -->
        <div v-else-if="key == vueQueValidationConfig.VALIDATION_ADDRESS_QUE">
          <div
            v-if="!(surveyQuestionWithDetails[''+qid][9] && surveyQuestionWithDetails[''+qid][9]['st_answer_text'] == 1)"
          >
            {{validationDetails.st_validation_name}}:
            <span
              v-if="validationDetails.st_answer_text"
            >True</span>
            <span v-else>False</span>
          </div>
        </div>
        <div v-else>
          <!-- Text child validations -->
          <div
            v-if="(key == vueQueValidationConfig.VALIDATION_SINGLE_LINE || key == vueQueValidationConfig.VALIDATION_PARAGRAPH || key == vueQueValidationConfig.VALIDATION_SERIAL_NUM) && validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_INPUT"
          >
            <span
              v-if="validationDetails.st_answer_text == 1"
            >Options: {{validationDetails.st_validation_name}}</span>
          </div>
          <!-- For image control -->
          <div
            class
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_IMAGE && validationDetails.st_answer_text && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_MULTIPLE_IMAGE ? (imgArray = [], imgArray = validationDetails.st_answer_text.split(/\n/)) : 0"
          >
            <!-- Not being used currently as max image set to 4 -->
            <div v-if="imgArray.length > 5">
              <div class="row" v-if="!showMore">
                Image:
                <div class="col-md-3 add-black-border" v-for="(k,i) in 5" :key="i">
                  <v-lazy-image :src="imgArray[i]"></v-lazy-image>
                </div>
                <a
                  id="expandShowMore"
                  class="add_show_more"
                  href="#"
                  @click.prevent="showMore=!showMore"
                >Show More</a>
              </div>
              <div class="row" v-if="showMore">
                Image:
                <div class="col-md-3 add-black-border" v-for="(img,k) in imgArray" :key="k">
                  <v-lazy-image :src="img"></v-lazy-image>
                </div>
                <a
                  id="expandShowMore"
                  class="add_show_more"
                  href="#"
                  @click.prevent="showMore=!showMore"
                >Show Less</a>
              </div>
            </div>
            <div v-else>
              <div class="label-control">Image:</div>
              <div class="row">
                <div
                  class="col-md-3 imageContainer add-black-border"
                  v-for="(img,k) in imgArray"
                  :key="k"
                >
                  <v-lazy-image :src="img" class="profileImagePreview"></v-lazy-image>
                </div>
              </div>
            </div>
          </div>
          <!-- For multiple-choice image control -->
          <div
            :class="validationDetails.st_answer_details.length > 5 ? '' :'row'"
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_IMAGE && validationDetails.in_question_type_id === vueQueTypeConfig.TYPE_MULTIPLE_IMAGE"
          >
            <div v-if="validationDetails.st_answer_details.length <= 5" class="col-md-12">Answers:</div>
            <div v-if="validationDetails.st_answer_details.length > 5">
              <div class="row" v-if="!showMore">
                <div class="col-md-12">Answers:</div>
                <div class="col-md-3 add-black-border" v-for="(k,i) in 5" :key="i">
                  <v-lazy-image :src="validationDetails.st_answer_details[i]"></v-lazy-image>
                  {{ validationDetails.st_answer_label_details[i]}}
                  <div
                    v-if="all.in_audit ? (scoreArray = [],scoreArray = validationDetails.st_answer_score.split('\n')): 0"
                  >
                    <span v-if="scoreArray[i]">(Score: {{scoreArray[i]}})</span>
                    <span v-else>Score: NA</span>
                  </div>
                  <a
                    v-if="ansInSkipLogic && ansInSkipLogic.indexOf(validationDetails.st_answer_path_details[i]) > -1"
                    class="skip-logic-icon"
                    href="#"
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Skip Logic Question"
                  >
                    <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                  </a>
                </div>
                <span v-if="allowOthers === 1">Other (Score: {{allowOthersScore}})</span>
                <a
                  id="expandShowMore"
                  class="add_show_more"
                  href="#"
                  @click.prevent="showMore=!showMore"
                >Show More</a>
              </div>
              <div class="row" v-if="showMore">
                <div class="col-md-12">Answers:</div>
                <div
                  class="col-md-3 add-black-border"
                  v-for="(img,k) in (validationDetails.st_answer_details)"
                  :key="k"
                >
                  <v-lazy-image :src="img"></v-lazy-image>
                  {{ validationDetails.st_answer_label_details[k] }}
                  <div
                    v-if="all.in_audit ?  (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
                  >
                    <span v-if="scoreArray[k]">(Score: {{scoreArray[k]}})</span>
                    <span v-else>Score: NA</span>
                  </div>
                  <a
                    v-if="ansInSkipLogic && ansInSkipLogic.indexOf(validationDetails.st_answer_path_details[k]) > -1"
                    class="skip-logic-icon"
                    href="#"
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Skip Logic Question"
                  >
                    <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                  </a>
                </div>
                <span v-if="allowOthers === 1">Other (Score: {{allowOthersScore}})</span>
                <a
                  id="expandShowMore"
                  class="add_show_more"
                  href="#"
                  @click.prevent="showMore=!showMore"
                >Show Less</a>
              </div>
            </div>
            <div
              v-else
              class="col-md-3 add-black-border"
              v-for="(img,k) in validationDetails.st_answer_details"
              :key="k"
            >
              <v-lazy-image :src="img"></v-lazy-image>
              {{ validationDetails.st_answer_label_details[k]}}
              <div
                v-if="all.in_audit ?(scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
              >
                <span v-if="scoreArray[k]">(Score: {{scoreArray[k]}})</span>
                <span v-else>Score: NA</span>
              </div>
              <a
                v-if="ansInSkipLogic && ansInSkipLogic.indexOf(validationDetails.st_answer_path_details[k]) > -1"
                class="skip-logic-icon"
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                title="Skip Logic Question"
              >
                <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
              </a>
            </div>
            <span v-if="allowOthers === 1">Other (Score: {{allowOthersScore}})</span>
          </div>
          <!-- Image flow -->
          <div
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_FLOW"
          >
            <span
              v-if="validationDetails.st_answer_text == 0"
            >{{validationDetails.st_validation_name}}: In one row</span>
            <span v-else>{{validationDetails.st_validation_name}}: In one column</span>
          </div>
          <!-- camera -->
          <div
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_CAMERA"
          >
            <span
              v-if="validationDetails.st_answer_text == 0"
            >{{validationDetails.st_validation_name}}: Front</span>
            <span v-else>{{validationDetails.st_validation_name}}: Rear</span>
          </div>
          <!-- end screen -->
          <div
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_TIMEOUT || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_BUTTON"
          >
            <span
              v-if="validationDetails.st_answer_text == 1"
            >Ending Scenerio: {{validationDetails.st_validation_name}}</span>
          </div>
          <!-- start end button text -->
          <div
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_BUTTON_TEXT"
          >
            <div
              v-if="surveyQuestionWithDetails[''+qid]['qval_47'] && surveyQuestionWithDetails[''+qid]['qval_47']['st_answer_text'] == 1 || validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_START_SCREEN_TEXT"
            >{{validationDetails.st_validation_name}}: {{validationDetails.st_answer_text}}</div>
          </div>
          <!--end screen Timeout -->
          <div
            v-else-if="validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_TIMEOUT_IN_SEC"
          >
            <div
              v-if="surveyQuestionWithDetails[''+qid]['qval_46'] && surveyQuestionWithDetails[''+qid]['qval_46']['st_answer_text'] == 1"
            >{{validationDetails.st_validation_name}}: {{validationDetails.st_answer_text}}</div>
          </div>
          <!-- date time -->
          <div
            v-else-if="(validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_MIN_DATE || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_MAX_DATE ) && validationDetails.st_answer_text"
          >{{validationDetails.st_validation_name}}: {{moment(validationDetails.st_answer_text).format(surveyQuestionWithDetails[''+qid][42]['st_answer_text'])}}</div>
          <div
            v-else-if="validationDetails.in_validation_id == (vueQueValidationConfig.VALIDATION_MIN_TIME || validationDetails.in_validation_id == vueQueValidationConfig.VALIDATION_MAX_TIME ) && validationDetails.st_answer_text"
          >
            {{validationDetails.st_validation_name}}: {{validationDetails.st_answer_text}}
            <!-- <div
              v-if="validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS"
            >{{validationDetails.st_validation_name}}: {{moment(validationDetails.st_answer_text, "HH:mm:ss ").format('hh:mm:ss A')}}</div>
            <div
              v-else
            >{{validationDetails.st_validation_name}}: {{moment(validationDetails.st_answer_text, "HH:mm:ss").format('HH:mm')}}</div>-->
          </div>
          <div v-else>
            <div
              v-if="validationDetails.st_answer_text && validationDetails.in_validation_id != vueQueValidationConfig.VALIDATION_MANDATORY_QUE"
            >
              {{validationDetails.st_validation_name}}:
              <div
                class="margin-bottom-zero"
                v-if="typeof(validationDetails.st_answer_text) == 'string' && (validationDetails.st_answer_text.indexOf('\n') > -1 || validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_OTHER || validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_STAR) ? (ansArray = [], ansArray = validationDetails.st_answer_text.split('\n')) : validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_SATISFACTION ? (ansArray = [], ansArray = validationDetails.st_answer_text.split('sep')) : 0"
              >
                <div v-if="ansArray.length > 5">
                  <div v-if="!showMore">
                    <div v-for="(k,i) in 5" :key="k">
                      {{ansArray[i]}}
                      <span
                        v-if="all.in_audit && (validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_LIST || validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_TEXT) ? (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
                      >
                        <span v-if="scoreArray[i]">(Score: {{scoreArray[i]}})</span>
                        <span v-else>(Score: NA)</span>
                      </span>
                      <a
                        v-if="ansInSkipLogic && ansInSkipLogic.indexOf(ansArray[i]) > -1"
                        class="skip-logic-icon"
                        href="#"
                        @click.prevent
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Skip Logic Question"
                      >
                        <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                      </a>
                    </div>
                    <a
                      id="expandShowMore"
                      class="add_show_more"
                      href="#"
                      @click.prevent="showMore=!showMore"
                    >Show More</a>
                  </div>
                  <div v-if="showMore">
                    <div v-for="(ans,k) in (ansArray)" :key="k">
                      {{ans}}
                      <span
                        v-if="all.in_audit && (validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_LIST || validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_TEXT) ? (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')): 0"
                      >
                        <span v-if="scoreArray[k]">(Score: {{scoreArray[k]}})</span>
                        <span v-else>(Score: NA)</span>
                      </span>
                      <a
                        v-if="ansInSkipLogic && ansInSkipLogic.indexOf(ans) > -1"
                        class="skip-logic-icon"
                        href="#"
                        @click.prevent
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Skip Logic Question"
                      >
                        <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                      </a>
                    </div>
                    <span v-if="allowOthers === 1">Other (Score: {{allowOthersScore}})</span>
                    <a
                      id="expandShowMore"
                      class="add_show_more"
                      href="#"
                      @click.prevent="showMore=!showMore"
                    >Show Less</a>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-if="(validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_LIST && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_YES_NO && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_MULTIPLE_TEXT && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_TRUE_FALSE && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_OTHER &&
                     validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_SATISFACTION &&
                     validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_STAR)"
                  >
                    <pre class="margin-bottom-zero">{{validationDetails.st_answer_text}}</pre>
                  </div>
                  <div
                    v-else-if="validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_SATISFACTION ? (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
                    v-for="(ans,k) in (validationDetails.st_answer_text.split('sep'))"
                    :key="k"
                  >
                    <span class="ck-span">
                      <i :class="smileyClass[ans]"></i>
                    </span>
                    <span v-if="all.in_audit">
                      <span v-if="scoreArray[k]">(Score: {{scoreArray[k]}})</span>
                      <span v-else>(Score : NA)</span>
                    </span>
                    <a
                      v-if="ansInSkipLogic && ansInSkipLogic.indexOf(ans) > -1"
                      class="skip-logic-icon"
                      href="#"
                      @click.prevent
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Skip Logic Question"
                    >
                      <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div
                    v-else
                    v-for="(ans,k) in (validationDetails.st_answer_text.split('\n'))"
                    :key="k"
                  >
                    <span
                      v-if="validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_STAR"
                      class="skiplogic rating"
                    >
                      <span class="icon" v-for="j in parseInt(ans)" :key="j">★</span>
                    </span>
                    <span v-else>{{ans}}</span>
                    <!-- Two choices yes no,true false multiple choice when less than 5 ans-->
                    <span
                      v-if="all.in_audit && (validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_STAR && validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_OTHER)  ? (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
                    >
                      <span v-if="scoreArray[k]">(Score: {{scoreArray[k]}})</span>
                      <span v-else>(Score: NA)</span>
                    </span>
                    <!-- Two choices others type -->
                    <span
                      v-else-if="all.in_audit && validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_OTHER"
                    >
                      <span
                        v-if="validationDetails.st_answer_score"
                      >(Score: {{validationDetails.st_answer_score}})</span>
                      <span v-else>(Score: NA)</span>
                    </span>
                    <!-- For rating star -->
                    <div
                      v-else-if="(all.in_audit || ansInSkipLogic && ansInSkipLogic.length > 0) && validationDetails.in_question_type_id == vueQueTypeConfig.TYPE_STAR ? (scoreArray = [], scoreArray = validationDetails.st_answer_score.split('\n')) : 0"
                    >
                      <div
                        class="margin-bottom-zero"
                        v-for="(s,i) in parseInt(validationDetails['st_answer_text'])"
                        :key="i"
                      >
                        <span class="skiplogic rating">
                          <span class="icon" v-for="j in i+1" :key="j">★</span>
                        </span>
                        <span v-if="all.in_audit && scoreArray[i]">(Score : {{scoreArray[i]}})</span>
                        <span v-else-if="all.in_audit">(Score : NA)</span>
                        <a
                          v-if="ansInSkipLogic && ansInSkipLogic.indexOf((i+1).toString()) > -1"
                          class="skip-logic-icon"
                          href="#"
                          @click.prevent
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Skip Logic Question"
                        >
                          <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <a
                      v-if="ansInSkipLogic && ansInSkipLogic.indexOf(ans) > -1"
                      class="skip-logic-icon"
                      href="#"
                      @click.prevent
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Skip Logic Question"
                    >
                      <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                    </a>
                  </div>
                  <span v-if="allowOthers === 1">Other (Score: {{allowOthersScore}})</span>
                </div>
              </div>
              <span v-else>
                <div
                  v-if="validationDetails.st_answer_text.indexOf('sep') > -1 ? validationDetails.st_answer_text = replaceAll(validationDetails.st_answer_text,'sep',',') : 1"
                >
                  {{validationDetails.st_answer_text}}
                  <a
                    v-if="ansInSkipLogic && ansInSkipLogic.indexOf(validationDetails.st_answer_text) > -1"
                    class="skip-logic-icon"
                    href="#"
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Skip Logic Question"
                  >
                    <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
                  </a>
                </div>
              </span>
            </div>
            <div v-else>
              <div
                v-if="validationDetails.in_validation_id != vueQueValidationConfig.VALIDATION_MANDATORY_QUE && (validationDetails.in_validation_id != vueQueValidationConfig.VALIDATION_IMAGE && (validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_START_SCREEN_TEXT || validationDetails.in_question_type_id != vueQueTypeConfig.TYPE_END_SCREEN_TEXT))"
              >{{validationDetails.st_validation_name}}: NA</div>
              <div
                v-if="validationDetails.in_question_type_id === vueQueTypeConfig.TYPE_SIGNATURE"
              >Options are not availaible.</div>
            </div>
            <!-- </span> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
var { queTypeConfig } = require("../../../config/config.js");
var { queValidationConfig } = require("../../../config/config.js");
export default {
  name: "expanddisplay",
  props: ["qid", "ansInSkipLogic"],
  data() {
    return {
      showMore: 0,
      qtypeToName: {
        1: "Input",
        2: "Display",
        4: "Yes/No",
        5: "Text",
        8: "Currency",
        10: "12-Hours",
        11: "True/False",
        12: "Other",
        13: "Image",
        14: "Number",
        15: "Telephone",
        16: "24-Hours",
        19: "Satisfaction",
        20: "Star"
      },
      vueQueTypeConfig: queTypeConfig,
      vueQueValidationConfig: queValidationConfig,
      allowOthers: 0,
      allowOthersScore: "NA",
      questionDetails: {},
      smileyClass: {
        ":)": "em em-smile",
        ":|": "em em-neutral_face",
        ":P": "em em-heart_eyes",
        ":@": "em em-angry",
        ":(": "em em-disappointed"
      }
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["all"]),
    ...mapGetters("editquestionEdit", {
      surveyQuestionWithAllDetails: "getSurveyQuestWithDetails"
    }),
    surveyQuestionWithDetails() {
      if (
        this.surveyQuestionWithAllDetails["" + this.qid]["zqval_45"] &&
        this.surveyQuestionWithAllDetails["" + this.qid]["zqval_45"][
          "in_question_type_id"
        ] == this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT
      ) {
        let tmpQ = this.surveyQuestionWithAllDetails;
        let tmnpVal = tmpQ["" + this.qid]["zqval_45"];
        delete tmpQ["" + this.qid]["zqval_45"];
        this.$set(tmpQ["" + this.qid], "zqval_45", tmnpVal);
        return tmpQ;
      } else {
        return this.surveyQuestionWithAllDetails;
      }
    }
  },
  methods: {
    replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, "g"), replace);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/expanddisplay.vue